(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8047],{

/***/ 5755:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tin-hay/[slug]",
      function () {
        return __webpack_require__(55015);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 28075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ GoogleBannerAds; },
/* harmony export */   "a": function() { return /* binding */ GoogleGridAds; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function GoogleBannerAds() {
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        try {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch (err) {
            console.log(err);
        }
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ins", {
        className: "adsbygoogle",
        style: {
            display: "block"
        },
        "data-ad-client": "ca-pub-2522844423315072",
        "data-ad-slot": "1281160371",
        "data-ad-format": "auto",
        "data-full-width-responsive": "true"
    });
}
function GoogleGridAds() {
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        try {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch (err) {
            console.log(err);
        }
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ins", {
        className: "adsbygoogle",
        style: {
            display: "block"
        },
        "data-ad-format": "autorelaxed",
        "data-ad-client": "ca-pub-2522844423315072",
        "data-ad-slot": "6470023398"
    });
}


/***/ }),

/***/ 55015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ PostPage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(27948);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(67720);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(11496);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25617);
/* harmony import */ var _components_GoogleAds__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28075);
/* harmony import */ var _components_HeaderBreadcrumbs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(991);
/* harmony import */ var _components_Page__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82771);
/* harmony import */ var _hooks_useLocales__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9671);
/* harmony import */ var _hooks_useSettings__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(40571);
/* harmony import */ var _layouts__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85307);
/* harmony import */ var _redux_slices_blog_blog_comment__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(29050);
/* harmony import */ var _redux_slices_blog_blog_post__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(20246);
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(33599);
/* harmony import */ var _routes_paths__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(76939);
/* harmony import */ var _sections_blog_post_PostDescription__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(3466);
/* eslint-disable react-hooks/exhaustive-deps */ /* eslint-disable react/prop-types */ 


















// ----------------------------------------------------------------------
var RootStyle = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)("div")(function(param) {
    var theme = param.theme;
    return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
        paddingBottom: theme.spacing(10),
        paddingTop: theme.spacing(10)
    }, theme.breakpoints.up("md"), {
        paddingTop: theme.spacing(12)
    });
});
PostPage.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layouts__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        variant: "main",
        children: page
    });
};
var __N_SSG = true;
function PostPage(param) {
    var currentItem = param.currentItem;
    var dispatch = (0,_redux_store__WEBPACK_IMPORTED_MODULE_11__/* .useDispatch */ .I0)();
    var themeStretch = (0,_hooks_useSettings__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)().themeStretch;
    var translate = (0,_hooks_useLocales__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)().translate;
    var ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.blogComment;
    }), searchComment = ref.search;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        dispatch((0,_redux_slices_blog_blog_post__WEBPACK_IMPORTED_MODULE_10__/* .setPost */ .Cd)(currentItem));
        dispatch((0,_redux_slices_blog_blog_comment__WEBPACK_IMPORTED_MODULE_9__/* .setCommentSearch */ .VG)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, searchComment), {
            value: "",
            page: 0,
            filterBys: {
                itemId: currentItem.id,
                type: "POST"
            }
        })));
    }, [
        currentItem
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Page__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        title: currentItem.title,
        description: currentItem.metaDescription,
        imagePath: currentItem.featureImage,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RootStyle, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                maxWidth: themeStretch ? "xl" : "lg",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .ZP, {
                    container: true,
                    spacing: 1,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .ZP, {
                        item: true,
                        xs: 12,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_HeaderBreadcrumbs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                heading: currentItem.title,
                                links: [
                                    {
                                        name: translate("menu.home"),
                                        href: _routes_paths__WEBPACK_IMPORTED_MODULE_12__/* .PATH_PAGE.home */ .ko.home
                                    },
                                    {
                                        name: translate("menu.blog"),
                                        href: _routes_paths__WEBPACK_IMPORTED_MODULE_12__/* .PATH_RESOURCE.blogs */ .U6.blogs
                                    },
                                    {
                                        name: currentItem.title
                                    }, 
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                sx: {
                                    mb: 2
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sections_blog_post_PostDescription__WEBPACK_IMPORTED_MODULE_13__/* .PostDescription */ .Q, {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_GoogleAds__WEBPACK_IMPORTED_MODULE_3__/* .GoogleGridAds */ .a, {})
                        ]
                    })
                })
            })
        })
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5101,1160,3362,917,2077,5410,6461,1739,892,4538,2298,3559,4397,2225,9419,9774,2888,179], function() { return __webpack_exec__(5755); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);